import React from 'react';
import { Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const linkedinUrl = "https://www.linkedin.com/in/sakshi-jain-luxurybmanagement/";
  const instagramUrl = "https://www.instagram.com/meerashi.consulting/";

  return (
    <footer className="editorial-footer">
      <div className="container">
        <div className="footer-content-editorial">
          <div className="footer-brand-editorial">
            <div className="footer-logo-editorial">
              <a href={linkedinUrl} target="_blank" rel="noopener noreferrer" className="logo-mark-link">
                <div className="logo-mark">M</div>
              </a>
            </div>
            <p className="footer-tagline-editorial">
              E-commerce Excellence for Fashion Brands
            </p>
            <div className="footer-contact-info">
              <a href="mailto:sakshi.jain@meerashi.com" className="footer-contact-link">
                sakshi.jain@meerashi.com
              </a>
              <a href="tel:+919769133161" className="footer-contact-link">
                +91 9769133161
              </a>
            </div>
          </div>

          <div className="footer-links-editorial">
            <a 
              href={linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link-editorial footer-social-link"
            >
              <Linkedin size={16} />
              <span>LinkedIn</span>
            </a>
            <a 
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link-editorial footer-social-link"
            >
              <Instagram size={16} />
              <span>@meerashi.consulting</span>
            </a>
          </div>
        </div>

        <div className="footer-bottom-editorial">
          <p>© {currentYear} Meerashi. All rights reserved.</p>
          <p>Fashion E-commerce Consulting | India</p>
        </div>
      </div>

      {/* Dripping text effect */}
      <div className="footer-drip-text">
        MEERASHI
      </div>
    </footer>
  );
};

export default Footer;
